import useAxiosInterceptor from './useAxiosInterceptor'

export default useAxiosInterceptor
